import script from "./MfaView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MfaView.vue?vue&type=script&setup=true&lang=ts"

import "./MfaView.vue?vue&type=style&index=0&id=12243b2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12243b2c"]])

export default __exports__